import { MINUTES_IN_DAY, MINUTES_IN_HOUR } from '@stdlib/constants-time';

export const slotsEndNextDay = (
  latestStartTime: string | null | undefined,
  durationMinutes: number | null
): boolean => {
  if (!latestStartTime || durationMinutes === null) {
    return false;
  }

  const [hours = 0, minutes = 0] = latestStartTime.split(':').map(Number);

  return hours * MINUTES_IN_HOUR + minutes + durationMinutes >= MINUTES_IN_DAY;
};
